import { RouteRecordRaw } from "vue-router";
import { useUserData } from "@/lib/mypage/useMypage";

import App from "@/App.vue";
import FrameMypage from "@/components/frameMypage.vue";
import FrameGroup from "@/components/frameGroup.vue";
import FrameUnit from "@/components/frameUnit.vue";
import Home from "@/views/Home.vue";
import Layout from "@/components/Layout.vue";
/*

    메인 라우터

*/
const routerHome: RouteRecordRaw = {
  path: "/",
  name: "router.home",
  component: Layout,
  children: [
    {
      path: "",
      component: Home,
    },
  ],
};

/*

  서비스 소개 라우터

*/
const routerService: RouteRecordRaw = {
  path: "/service",
  name: "router.service",
  component: Layout,
  children: [
    {
      path: "",
      name: "router.service-service",
      component: () => import("@/views/business/service.vue"),
    },
  ],
};

/*

    주문접수 라우터

*/
const routerOutbound: RouteRecordRaw = {
  path: "/outbound",
  name: "router.outbound",
  redirect: "/outbound/complete",
  component: Layout,
  meta: {
    requireAuth: true,
  },
  children: [
    {
      path: "parcel",
      name: "router.outbound-parcel",
      component: () => import("@/views/outbound/parcel.vue"),
    },
    {
      path: "quick",
      name: "router.outbound-quick",
      component: () => import("@/views/outbound/quick.vue"),
    },
    {
      path: "mass-parcel",
      name: "router.outbound-mass-parcel",
      component: () => import("@/views/outbound/massParcel.vue"),
    },
    {
      path: "registry",
      name: "router.outbound-registry",
      component: () => import("@/views/outbound/registry.vue"),
    },
    {
      path: "global",
      name: "router.outbound-global",
      component: () => import("@/views/outbound/globalMail.vue"),
    },
    {
      path: "complete",
      name: "router.outbound-complete",
      component: () => import("@/views/outbound/complete.vue"),
    }
  ],
};

/*

    배송조회 라우터

*/
const routerTracking: RouteRecordRaw = {
  path: "/tracking",
  name: "router.tracking",
  redirect: "/tracking/outbound",
  meta: {
    requireAuth: true,
  },
  component: Layout,
  children: [
    {
      path: "outbound",
      name: "router.tracking-outbound",
      component: () => import("@/views/tracking/outbound.vue"),
    },
    {
      path: "outbound-detail",
      name: "router.tracking-outbound-detail",
      component: () => import("@/views/tracking/outboundDetail.vue"),
    },
    {
      path: "inbound",
      name: "router.tracking-inbound",
      component: () => import("@/views/tracking/inbound.vue"),
    },
    {
      path: "inbound-detail",
      name: "router.tracking-inbound-detail",
      component: () => import("@/views/tracking/inboundDetail.vue"),
    },
  ],
};

/*

    고객지원 라우터

*/
const routerHelp: RouteRecordRaw = {
  path: "/help",
  name: "router.help",
  redirect: "/help/notice",
  component: Layout,
  children: [
    {
      path: "notice",
      name: "router.help-notice",
      component: () => import("@/views/help/notice.vue"),
    },
    {
      path: "faq",
      name: "router.help-faq",
      component: () => import("@/views/help/faq.vue"),
    },
  ],
};

/**
 * 고객혜택 라우터
 */
const routerBenefit: RouteRecordRaw = {
  path: "/client",
  name: "router.benefit",
  component: Layout,
  children: [
    {
      path: "benefit",
      name: "router.benefit.child",
      component: () => import("@/views/client/benefit.vue"),
    },
  ],
};

/*

    마이페이지 라우터

*/
const routerMypage: RouteRecordRaw = {
  path: "/mypage",
  name: "router.mypage",
  redirect: "/mypage/profile",
  beforeEnter: async () => {
    const { setupUserData } = useUserData();
    await setupUserData();
  },
  component: FrameMypage,
  meta: {
    requireAuth: true,
  },
  children: [
    {
      path: "profile",
      name: "router.mypage-profile",
      component: () => import("@/views/mypage/profile.vue"),
    },
    {
      path: "billing",
      name: "router.mypage-billing",
      component: () => import("@/views/mypage/billing.vue"),
    },
    {
      path: "unit",
      name: "router.mypage-unit",
      component: FrameUnit,
      children: [
        {
          path: "admin-host-unit-info",
          name: "router.mypage-unit-admin-sub.admin-host-unit-info",
          component: () => import("@/views/unit/unitGroupInfo.vue"),
        },
        {
          path: "admin-unit-member-info",
          name: "router.mypage-unit-admin-sub.admin-unit-member-info",
          component: () => import("@/views/unit/unitMember.vue"),
        },
        {
          path: "admin-host-unit-approve",
          name: "router.mypage-unit-admin-sub.admin-host-unit-approve",
          component: () => import("@/views/unit/unitApprove.vue"),
        },
        {
          path: "admin-host-unit-history",
          name: "router.mypage-unit-admin-sub.admin-host-unit-history",
          component: () => import("@/views/unit/unitUseHistory.vue"),
        },
        {
          path: "unit-group-detail",
          name: "router.mypage-unit-admin-sub.unit-group-detail",
          component: () => import("@/views/unit/unitGroupDetail.vue"),
        },
        {
          path: "unit-member-detail",
          name: "router.mypage-unit-admin-sub.unit-member-detail",
          component: () => import("@/views/unit/unitMemberDetail.vue"),
        },
      ],
    },
  ],
};

/*

  로그인 라우터

*/
const routerSignin: RouteRecordRaw = {
  path: "/signin",
  name: "router.signin",
  component: Layout,
  children: [
    {
      path: "",
      name: "router.signin.child",
      component: () => import("@/views/sign/signin.vue"),
    },
    {
      path: "sso",
      name: "router.sso",
      component: () => import("@/views/sign/sso.vue"),
    },
  ],
};

/*

  회원가입 라우터

*/
const routerSignup: RouteRecordRaw = {
  path: "/signup",
  name: "router.signup",
  component: Layout,
  children: [
    {
      path: "",
      name: "router.signup.child",
      component: () => import("@/views/sign/signup.vue"),
    },
    {
      path: "info",
      name: "router.signup-info",
      component: () => import("@/views/sign/signup-info.vue"),
    },
  ],
};
/*

  sso 라우터

*/
const routerSSO: RouteRecordRaw = {
  path: "/sso/callback/:vendor",
  name: "router.sso-callback",
  component: () => import("@/views/sign/sso-callback.vue"),
};

/*

  oauth 라우터

*/
const routerOauth: RouteRecordRaw = {
  path: "/oauth",
  name: "router.ouath",
  redirect: "/",
  component: App,
  children: [
    {
      path: "naver",
      name: "router.oauth-naver",
      component: () => import("@/views/oauth/naver.vue"),
    },
    {
      path: "kakao",
      name: "router.oauth-kakao",
      component: () => import("@/views/oauth/kakao.vue"),
    },
  ],
};

const routerNotFound: RouteRecordRaw = {
  path: "/:pathMatch(.*)*",
  name: "NotFound",
  component: Layout,
  children: [
    {
      path: "",
      name: "NotFoundChild",
      component: () => import("@/views/404.vue"),
    },
  ],
};

export {
  routerHome,
  routerOutbound,
  routerTracking,
  routerHelp,
  routerMypage,
  routerSignin,
  routerSignup,
  routerOauth,
  routerSSO,
  routerService,
  routerBenefit,
  routerNotFound,
};
